import { format } from 'date-fns'
import { FC } from 'react'

import { CopyButton } from '@/components/global/copy-button'
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table'
import { Admin } from '@/watch-tower/out/admin'

type Props = {
  admins: Admin[]
}

const AdminsTable: FC<Props> = ({ admins }) => {
  return (
    <div className="border rounded-md">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead className="pl-6">Admin</TableHead>
            <TableHead>Added</TableHead>
            <TableHead>Timezone</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {admins.map(admin => (
            <TableRow key={admin.id} className="transition-colors hover:bg-inherit">
              <TableCell>
                <div className="flex items-center space-x-4">
                  {admin.photo ? (
                    <img src={admin.photo} className="w-12 h-12 rounded" />
                  ) : (
                    <div className="w-12 h-12 rounded bg-muted/50" />
                  )}
                  <div className="flex flex-col justify-center">
                    <span className="font-medium">
                      {admin.firstName} {admin.lastName}
                    </span>
                    <div className="relative flex items-center gap-1 text-sm text-muted-foreground">
                      {admin.email}
                      <CopyButton text={admin.email} small />
                    </div>
                  </div>
                </div>
              </TableCell>
              <TableCell>{format(new Date(), 'MMM d, yyyy')}</TableCell>
              <TableCell>{admin.timeZone ?? <span className="text-muted-foreground">unknown</span>}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}

export default AdminsTable
